import { useEffect } from "react";

export default function useScenarioModellingMarkers({
    mapRef,
    longstandingGeoJSONRef,
    SMSelectedArray = [],
    scenarioHighlightedFeatureIds = [],
}) {
    useEffect(() => {
        if (!mapRef.current) return;

        const features = longstandingGeoJSONRef.current?.features;

        if (!features?.length) return;

        const highlightedIds = new Set([
            ...SMSelectedArray.map(String),
            ...scenarioHighlightedFeatureIds.map(String),
        ]);
        const selectedFeatures = features.filter((feature) =>
            highlightedIds.has(String(feature.skylark_id))
        );

        const selectedGeoJSON = {
            type: "FeatureCollection",
            features: selectedFeatures.map((feature) => ({
                type: "Feature",
                geometry: feature.geometry,
                properties: {
                    skylark_id: feature.skylark_id,
                },
            })),
        };

        const map = mapRef.current;
        const updateScenarioOutline = () => {
            if (!mapRef.current || !map.isStyleLoaded()) return;

            if (map.getSource("scenario-modelling-feature-source")) {
                map.getSource("scenario-modelling-feature-source").setData(selectedGeoJSON);
            } else {
                map.addSource("scenario-modelling-feature-source", {
                    type: "geojson",
                    data: selectedGeoJSON,
                });
            }

            if (!map.getLayer("scenario-modelling-feature-outline")) {
                map.addLayer({
                    id: "scenario-modelling-feature-outline",
                    type: "line",
                    source: "scenario-modelling-feature-source",
                    paint: {
                        "line-color": "#D63384",
                        "line-width": 4,
                        "line-opacity": 1,
                    },
                });
            }
        };

        if (map.isStyleLoaded()) updateScenarioOutline();
        else map.once("style.load", updateScenarioOutline);

        return () => map.off("style.load", updateScenarioOutline);
    }, [mapRef, longstandingGeoJSONRef, SMSelectedArray, scenarioHighlightedFeatureIds]);
}
